<template>
    <VJoyPanel class="appendix-upload-panel">
        <template #panel-title>{{ $t('projectclient.quote.view.appendix.title') }}</template>
        <template #panel-body>
            <VJoyWrapper row-gap="0" direction="column" align="flex-start">
                <p class="appendix-upload-panel__section-subtitle-gray">
                    {{ $t('projectclient.quote.view.appendix.subtitle') }}
                </p>

                <div v-if="loading" class="appendix-upload-panel__loading">
                    <VJoySpinner />
                </div>
                <div v-else>
                    <ViewDocument
                        v-if="quote.appendix?.fileName"
                        :name="quote.appendix?.fileName"
                        :download-url="quote.appendix?.fileUrl"
                        :upload-date="quote.appendix?.uploadedDate"
                        :hide-preview="true"
                        deletable
                        @delete="deleteAppendix"
                    />

                    <VJoyDropzone
                        v-else
                        v-model="receiptFile"
                        name="appendixFile"
                        :accept="['application/pdf', 'image/jpeg', 'image/png']"
                        :max-size="5"
                        :multiple="false"
                        class="appendix-upload-panel__dopzone"
                    ></VJoyDropzone>
                </div>
            </VJoyWrapper>
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {ref, watch} from 'vue';
    import {VJoyWrapper, VJoyPanel, VJoyDropzone, VJoyHighlight, VJoySpinner} from '@maltjoy/core-vue';
    import type {QuoteResource} from '@api';
    import {ViewDocument} from '~/common/ui';
    import {useClientQuoteViewStore} from '../../stores';

    const props = defineProps<{
        quote: QuoteResource;
    }>();

    const clientQuoteStore = useClientQuoteViewStore();
    const receiptFile = ref<File[]>([]);
    const loading = ref(false);

    watch(receiptFile, () => {
        const file: File | null = receiptFile.value.length ? receiptFile.value[0] : null;

        if (file) {
            uploadAppendix(file);
        } else {
            deleteAppendix();
        }
    });

    async function uploadAppendix(file: File) {
        loading.value = true;

        await clientQuoteStore.uploadAppendixFile(props.quote.id, file);

        loading.value = false;
    }

    async function deleteAppendix() {
        loading.value = true;

        await clientQuoteStore.deleteAppendixFile(props.quote.id);
        await clientQuoteStore.getQuote(props.quote.id);

        loading.value = false;
    }
</script>

<style scoped lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .appendix-upload-panel {
        &__section-subtitle-gray {
            color: var(--joy-color-neutral-40);
        }

        &__loading {
            margin-bottom: var(--joy-core-spacing-6);
        }

        &__dopzone {
            margin-top: var(--joy-core-spacing-4);
        }
    }
</style>
